import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, MapPin, Gift, Wallet, Headphones, Bell, Settings, LogOut, ChevronRight, ClipboardList, Star, User, Award, Pencil } from "lucide-react";
import CustomerLayout from "@/components/customer/CustomerLayout";
import { useAuth } from "@/context/AuthContext";
import { EditProfileSheet } from "@/components/customer/EditProfileSheet";

const LINKS = [
  ["/orders", ClipboardList, "Your Orders", "Track, reorder & invoices"],
  ["/favorites", Heart, "Favorites", "Saved restaurants & dishes"],
  ["/addresses", MapPin, "Addresses", "Manage delivery locations"],
  ["/offers", Gift, "Offers & Coupons", "Deals just for you"],
  ["/rewards", Award, "BiteGoFood Rewards", "Points, levels & referrals"],
  ["/notifications", Bell, "Notifications", "Order & offer updates"],
  ["/support", Headphones, "Help & Support", "FAQs, tickets & chat"],
];

export default function Profile() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const [editing, setEditing] = useState(false);
  return (
    <CustomerLayout>
      <div className="bg-gradient-to-b from-coral to-coral-dark text-white px-5 pt-8 pb-6 rounded-b-3xl">
        <div className="flex items-center gap-3">
          <div className="w-16 h-16 rounded-full bg-white/20 overflow-hidden flex items-center justify-center">{user?.photo ? <img src={user.photo} alt="" className="w-full h-full object-cover" /> : <User size={30} />}</div>
          <div className="min-w-0 flex-1"><h1 className="font-display font-extrabold text-xl truncate">{user?.name}</h1><p className="text-white/85 text-sm">+91 {user?.phone}</p></div>
          <button onClick={() => setEditing(true)} className="bg-white/20 rounded-full px-3 py-2 text-sm font-semibold flex items-center gap-1.5 tap" data-testid="edit-profile-btn"><Pencil size={15} /> Edit</button>
        </div>
        <div className="grid grid-cols-3 gap-2 mt-5">
          <Stat icon={Award} v={user?.reward_points ?? 0} l="Points" onClick={() => nav("/rewards")} />
          <Stat icon={Heart} v="Saved" l="Favorites" onClick={() => nav("/favorites")} />
          <Stat icon={Star} v="4.8" l="Your rating" />
        </div>
      </div>
      <div className="px-4 py-4 space-y-2">
        {LINKS.map(([to, Icon, title, sub]) => (
          <button key={to} onClick={() => nav(to)} className="w-full flex items-center gap-3 bg-white rounded-2xl border border-border p-3.5 tap text-left" data-testid={`profile-link-${to}`}>
            <div className="w-10 h-10 rounded-xl bg-coral-light flex items-center justify-center"><Icon size={19} className="text-coral" /></div>
            <div className="flex-1 min-w-0"><div className="font-bold text-sm text-ink">{title}</div><div className="text-xs text-ink-600 truncate">{sub}</div></div>
            <ChevronRight size={18} className="text-ink-600" />
          </button>
        ))}
        <button onClick={() => { logout(); nav("/login"); }} className="w-full flex items-center gap-3 bg-white rounded-2xl border border-border p-3.5 tap text-left" data-testid="logout-btn">
          <div className="w-10 h-10 rounded-xl bg-red-50 flex items-center justify-center"><LogOut size={19} className="text-bad" /></div>
          <div className="font-bold text-sm text-bad">Log out</div>
        </button>
        <p className="text-center text-[11px] text-ink-600 pt-3">BiteGoFood · Food Near You, Faster Than Ever.<br/>A Product by Vijay Software Solutions Pvt Ltd</p>
      </div>
      <EditProfileSheet open={editing} onClose={() => setEditing(false)} />
    </CustomerLayout>
  );
}
function Stat({ icon: Icon, v, l, onClick }) {
  return <button onClick={onClick} className="bg-white/15 rounded-xl py-2.5 flex flex-col items-center tap"><Icon size={18} /><span className="font-bold text-sm mt-1">{v}</span><span className="text-[10px] text-white/80">{l}</span></button>;
}
